import React from 'react';

export const ArrowIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 30">
      <path d="M2.10352 13.7576V13.7586H2.11133L13.1768 14.9774L2.11133 16.1961C1.48068 16.2658 0.908807 15.8443 0.77832 15.2361L0.758789 15.1111L0.757812 15.1024L0.749023 14.9627C0.750671 14.2683 1.39554 13.6724 2.10352 13.7576Z"  fill="currentColor" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M9.5658 29.3738C12.4775 23.6469 16.4041 18.5591 20.5487 13.6921V16.263C17.4278 12.645 14.5044 8.86312 11.9525 4.81218C11.1057 3.44627 10.2824 2.05988 9.5658 0.58136C12.2435 2.41964 14.6331 4.54894 16.9672 6.76892C19.2647 8.97134 21.432 11.2937 23.5174 13.6921C24.1697 14.4365 24.1521 15.5377 23.5174 16.263C19.2924 21.0598 14.8189 25.6738 9.5658 29.3738Z"  fill="currentColor"/>
    </svg>
  );
};